import React from "react";
import { useForm, useFormState } from "react-hook-form";

import { yupResolver } from "@hookform/resolvers/yup";
import { yup } from "utils";

import useShareResources from "./useShareResources";

const validationSchema = () => {
  const emailSchema = yup.string().email();

  return {
    emails: yup
      .array()
      .min(1, "Please enter at least one email address")
      .test("is-valid-email", (value, ctx) => {
        const invalidEmails = value?.filter((v) => {
          return !emailSchema.isValidSync(v);
        });

        return invalidEmails.length > 0
          ? ctx.createError({
              message: (
                <span>
                  <b>{invalidEmails.join(", ")}</b>{" "}
                  {invalidEmails.length > 1
                    ? "are not valid email addresses"
                    : "is not a valid email address"}
                </span>
              ),
            })
          : true;
      }),
    processes: yup
      .object()
      .test(
        "at-least-one-selected",
        "Please select at least one process",
        (value) => {
          return Object.values(value || {}).some((selected) => {
            return selected;
          });
        }
      ),
  };
};

export function useShareResourcesForm(onSubmit, process) {
  const formProps = useForm({
    mode: "onChange",
    resolver: yupResolver(yup.object(validationSchema())),
    defaultValues: {
      emails: [],
      processes: process ? { [process.id]: true } : {},
    },
  });

  const { shareProcesses, isLoading } = useShareResources(onSubmit);

  const { isValid } = useFormState({ control: formProps.control });

  return {
    formProps: formProps,
    isReady: isValid,
    submit: formProps.handleSubmit(({ emails, processes }) => {
      shareProcesses({ emails, processes });
    }),
    isSubmitting: isLoading,
  };
}

export default useShareResourcesForm;
